'use client';

import Link from 'next/link';
import { useConsent } from '../contexts/ConsentContext';
import { useRouter } from 'next/router';
import { isFinnishPage } from '../lib/blogPaths';

export function CookieBanner() {
  const { consent, setConsent, hasDecided, mounted } = useConsent();
  const router = useRouter();
  const isFinnish = isFinnishPage(router?.pathname);

  if (!mounted || hasDecided) return null;

  const message = isFinnish
    ? 'Käytämme evästeitä parantaaksemme käyttökokemusta ja analytiikkaa. Voit hyväksyä kaikki tai vain välttämättömät.'
    : 'We use cookies to improve your experience and for analytics. You can accept all or only necessary cookies.';

  const acceptLabel = isFinnish ? 'Hyväksy kaikki' : 'Accept all';
  const declineLabel = isFinnish ? 'Vain välttämättömät' : 'Only necessary';
  const policyLabel = isFinnish ? 'Tietosuojakäytäntö' : 'Privacy Policy';

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[9999] p-4 md:p-6 bg-[#0f172a] border-t border-white/10 shadow-[0_-4px_20px_rgba(0,0,0,0.15)]"
      role="dialog"
      aria-label="Cookie consent"
    >
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <p className="text-sm text-gray-300 leading-relaxed">
          {message}{' '}
          <Link
            href={isFinnish ? '/tietosuojaseloste' : '/privacy-policy'}
            className="text-highlight hover:underline font-medium touch-manipulation"
          >
            {policyLabel}
          </Link>
        </p>
        <div className="flex flex-wrap items-center gap-3 shrink-0">
          <button
            type="button"
            onClick={() => setConsent(false)}
            className="px-4 py-2.5 text-sm font-medium text-gray-300 hover:text-white border border-white/20 rounded-lg transition-colors touch-manipulation"
          >
            {declineLabel}
          </button>
          <button
            type="button"
            onClick={() => setConsent(true)}
            className="px-4 py-2.5 text-sm font-medium bg-brand hover:bg-brand-hover text-white rounded-lg transition-colors touch-manipulation"
          >
            {acceptLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
